import { type ComponentInternalInstance } from "vue";
export function isPromise(val: any): val is Promise<any> {
  return val && typeof val.then === "function" && typeof val.catch === "function";
}

export function findParentInstance(
  name: string,
  instance?: ComponentInternalInstance | null | undefined
): ComponentInternalInstance | null | undefined {
  if (!instance) return null;
  if (instance?.type.name !== name) {
    return findParentInstance(name, instance?.parent);
  }
  return instance;
}
